export class SessionStorageService {
    private static tokenStore: Record<string, string> = {};

    private static readonly KEYS = {
        AUTH_TOKEN: 'authToken',
        KC_TOKEN: 'kcToken',
        KC_REFRESH_TOKEN: 'kcRefreshToken',
        ID_TOKEN: 'idToken',
        AUTHORIZATION_TOKEN: 'authorizationToken',
        AUTH_PROVIDER: 'authProvider',
    } as const;

    static setAuthToken(token: string): void {
        this.setItem(this.KEYS.AUTH_TOKEN, token);
    }

    static getAuthToken(): string | null {
        return this.getItem(this.KEYS.AUTH_TOKEN);
    }

    static setKeycloakToken(token: string): void {
        this.setItem(this.KEYS.KC_TOKEN, token);
    }

    static getKeycloakToken(): string | null {
        return this.getItem(this.KEYS.KC_TOKEN);
    }

    static setKeycloakRefreshToken(token: string): void {
        this.setItem(this.KEYS.KC_REFRESH_TOKEN, token);
    }

    static getKeycloakRefreshToken(): string | null {
        return this.getItem(this.KEYS.KC_REFRESH_TOKEN);
    }

    static setIdToken(token: string): void {
        this.setItem(this.KEYS.ID_TOKEN, token);
    }

    static getIdToken(): string | null {
        return this.getItem(this.KEYS.ID_TOKEN);
    }

    static setAuthorizationToken(token: string): void {
        this.setItem(this.KEYS.AUTHORIZATION_TOKEN, token);
    }

    static getAuthorizationToken(): string | null {
        return this.getItem(this.KEYS.AUTHORIZATION_TOKEN);
    }

    static setAuthProvider(provider: string): void {
        this.setItem(this.KEYS.AUTH_PROVIDER, provider);
    }

    static getAuthProvider(): string | null {
        return this.getItem(this.KEYS.AUTH_PROVIDER);
    }

    static setKeycloakTokens(tokens: {
        accessToken: string;
        refreshToken?: string;
        idToken?: string;
    }): void {
        this.setAuthToken(tokens.accessToken);
        this.setKeycloakToken(tokens.accessToken);

        if (tokens.refreshToken) {
            this.setKeycloakRefreshToken(tokens.refreshToken);
        }

        if (tokens.idToken) {
            this.setIdToken(tokens.idToken);
        }
    }

    static clearAllTokens(): void {
        this.removeItem(this.KEYS.AUTH_TOKEN);
        this.removeItem(this.KEYS.KC_TOKEN);
        this.removeItem(this.KEYS.KC_REFRESH_TOKEN);
        this.removeItem(this.KEYS.ID_TOKEN);
        this.removeItem(this.KEYS.AUTHORIZATION_TOKEN);
    }

    static clearAll(): void {
        this.tokenStore = {};
    }

    static hasValidSession(): boolean {
        const authToken = this.getAuthToken();
        const kcToken = this.getKeycloakToken();

        return !!(authToken || kcToken);
    }

    private static setItem(key: string, value: string): void {
        this.tokenStore[key] = value;
    }

    private static getItem(key: string): string | null {
        return this.tokenStore[key] || null;
    }

    private static removeItem(key: string): void {
        delete this.tokenStore[key];
    }
}

export const inMemoryTokenStorage = SessionStorageService;